type ConsentsType = Record<string, { accepted: boolean }>;

/**
 * Converts an array of consent keys into an object where each key has a default structure.
 * The default structure is an object with an 'accepted' property set to false.
 */
export const convertConsentKeyToObject = (arr: string[]): ConsentsType =>
    arr.reduce((acc, curr) => {
        Object.assign(acc, { [curr]: { accepted: false } });
        return acc;
    }, {});

/**
 * Processes consent data based on provided keys and form data.
 * It converts the keys into a consent object with default values and then updates the object
 * based on the form data to reflect which consents have been accepted.
 */
export const handleConsent = ({
    keys,
    formData,
}: {
    keys: string[] | undefined;
    formData: Record<string, unknown>;
}): ConsentsType | null => {
    if (!keys?.length) return null;

    const consentsData = convertConsentKeyToObject(keys);

    keys.forEach((key) => {
        if (Object.hasOwn(formData, key))
            Object.assign(consentsData, {
                [key as keyof typeof consentsData]: {
                    accepted: !!formData[key],
                },
            });
    });

    return consentsData;
};
